import { css } from "@emotion/react";
import { fontFamilyMap } from "@hl/communities-app/src/styles/global/fonts";

import { CornersShape } from "apollo/graphql.generated";
import Rounded from "assets/icons/rounded-corner.svg";
import Square from "assets/icons/square-corner.svg";

export const container = css`
  display: flex;
  flex-direction: column;
  gap: 32px;
  position: relative;
`;

export const rowContainer = css`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

const getShapeIcon = (shape: string): string => {
  switch (shape.toLowerCase()) {
    case CornersShape.Rounded.toLowerCase():
      return Rounded;
    case CornersShape.Square.toLowerCase():
      return Square;
    default:
      return Square;
  }
};

export const selectShapeInput = (shape: string) => css`
  select {
    padding: 14px 8px 14px 42px;
    background-image: url(${getShapeIcon(shape)});
    background-repeat: no-repeat;
    background-size: 16px 16px;
    background-position: 16px center;
  }
`;

export const selectFonts = (font: string) =>
  css`
    select {
      font-family: ${fontFamilyMap[font]};
    }
  `;
